import React, { createContext, useContext, useState } from 'react'

const initial = {
  initialized: false,
  setInitialized: initialize => {}
}
export const GAContext = createContext(initial)
const GAContextProvider = ({ children }) => {
  const [initialized, setInitialized] = useState(false)
  return (
    <GAContext.Provider value={{ initialized, setInitialized }}>
      {children}
    </GAContext.Provider>
  )
}

export default GAContextProvider
export const useGAContext = () => useContext(GAContext)




// WEBPACK FOOTER //
// ./src/contexts/GAContext.js